import store from "../../redux/store";
import {catchUpLoadingLog} from "../../logs/logs";
import {ConditionName, zIndex} from "../../interfaces/enums";
import {conditions} from "../../helpers/conditions/conditions";
import {progressBar, progressBarWidth, videoTag} from "../../helpers/constants";
import { activeElementsTime, footerPadding } from "../../helpers/environment";
import {
    setActiveElements,
    setActivePointerProgressBar,
    setDelayTurnOffControlbar,
    setTooltipTime
} from "../slices/controllerSlice";
import { secondsToHMS } from "../../helpers/helpers";
import { handleVideoTimeline } from "./controller.actions";
import {setInfo} from "../slices/videoDataSlice";
import { sendFluentLog } from "../../logs/fluentdLogger";

export const getPointerTime = (event: any, type: string = "") => {
    const {videoElementSizeInfo} = store.getState().videoData;
    const {duration, hlsLiveSyncPosition} = store.getState().controller;
    const durationValue = conditions(ConditionName.isLiveParam) ? hlsLiveSyncPosition : duration;
    const clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
    if (clientX <= videoElementSizeInfo.right - footerPadding() && clientX > footerPadding()) {
        let positionX = clientX - footerPadding() - videoElementSizeInfo.left;
        let timePositionX = (positionX / (videoElementSizeInfo.width - 2 * footerPadding())) * durationValue;
        if (type === "tooltipTime-live") timePositionX = durationValue - timePositionX;
        return timePositionX
    }

}

export const getPointerPosition = (event: any) => {
    const {videoElementSizeInfo} = store.getState().videoData;
    const clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
    if (clientX <= videoElementSizeInfo.right - footerPadding() && clientX > footerPadding()) {
        return clientX - footerPadding() - videoElementSizeInfo.left;
    }
}

export const getMarkerPosition = (markerTime: number) => {
    const {duration, hlsLiveSyncPosition} = store.getState().controller;
    const durationValue = conditions(ConditionName.isLiveParam) ? hlsLiveSyncPosition : duration;
    return (markerTime * progressBarWidth()) / durationValue;
}

export const hideProgressTooltip = (progressTooltip: any) => {
    if (progressTooltip) {
        progressTooltip.style.opacity = "0.0";
        progressTooltip.style.pointerEvents = "none";
        progressTooltip.style.zIndex = zIndex.vttDisable;
    }
}

const generalStyleTooltipHandler = (progressTooltip: any) => {
    progressTooltip.style.display = "block";
    progressTooltip.style.zIndex = zIndex.vtt;
    progressTooltip.style.opacity = !!store.getState().videoData.details.vtt ? "1.0" : "0.6";
    progressTooltip.style.pointerEvents = "auto";
    progressTooltip.style.transition = "opacity 1s ease-out";
}

const vttTooltipStyleHandler = (event: any, progressTooltip: any) => {
    const element: any = document.getElementsByClassName("pl-progressTooltip")[0];
    const parentPlayer: any = document.getElementById("parent-player");
    if (element && parentPlayer) {
        if (getPointerPosition(event)! >= (parentPlayer.offsetLeft === 0 ? element.offsetWidth : parentPlayer.offsetLeft) && (getPointerPosition(event)! + element.offsetWidth) <= (videoTag().offsetLeft + videoTag().offsetWidth)) {
            progressTooltip.style.left = `${getPointerPosition(event)! - (element.offsetWidth / 2)}px`;
        } else if (getPointerPosition(event)! < (parentPlayer.offsetLeft === 0 ? element.offsetWidth : parentPlayer.offsetLeft)) {
            progressTooltip.style.left = `${0}px`;
        } else if ((videoTag().offsetLeft + videoTag().offsetWidth) < (getPointerPosition(event)! + element.offsetWidth)) {
            progressTooltip.style.left = `${videoTag().offsetWidth - element.offsetWidth}px`;
        }
    }
}

export const showProgressTooltip = (event: any, progressTooltip: any, progressBarTooltip: any) => {
    if (progressTooltip) generalStyleTooltipHandler(progressTooltip);
    if (store.getState().videoData.details.vtt) vttTooltipStyleHandler(event, progressTooltip);  // have vtt
    else progressTooltip.style.left = `${getPointerPosition(event)! - 30}px`;            // not vtt
    store.dispatch(setTooltipTime(Number(getPointerTime(event)!)));
    progressBarTooltip.textContent = conditions(ConditionName.isLiveParam) ? `-${secondsToHMS(getPointerTime(event, "tooltipTime-live")!)}` : `${secondsToHMS(getPointerTime(event)!)}`;
}

export const handleTimeTooltip = (event: any, isTimer: boolean = false) => {
    const {videoElementSizeInfo} = store.getState().videoData;
    const progressTooltip: any = document.querySelector(".pl-progressTooltip");
    const progressBarTooltip: any = document.querySelector(".pl-progressTimeTooltip");
    const clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
    if (progressTooltip && progressBarTooltip && clientX <= videoElementSizeInfo.right - footerPadding() && clientX > videoElementSizeInfo.left + footerPadding()) {
        showProgressTooltip(event, progressTooltip, progressBarTooltip);
        if (isTimer) setTimeout(() => hideProgressTooltip(progressTooltip), 2000);
    } else hideProgressTooltip(progressTooltip);
}

export const handleProgressTime = (event: any) => {
    const clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
    if (progressBar()) {
        if (clientX <= event.view.innerWidth - footerPadding() && clientX > footerPadding()) progressBar().style.width = `${getPointerPosition(event)}px`;
        else if (clientX <= event.view.innerWidth - footerPadding()) progressBar().style.width = 0;
        else if (clientX > footerPadding()) progressBar().style.width = `100%`;
    }
}

export const handlePointerDown = (event: any, timeoutIds: any, setIsPointerDown: (value:boolean) => void) => {
    setIsPointerDown(true);
    const dispatch = store.dispatch;
    const clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
    if (clientX <= event.view.innerWidth - footerPadding() && clientX > footerPadding()) {
        dispatch(setActivePointerProgressBar(true));
        dispatch(setDelayTurnOffControlbar(true));
        sessionStorage.setItem("previousVideoTime", String(videoTag().currentTime))
        event.target.setPointerCapture(event.pointerId);
        if (timeoutIds.length > 0) timeoutIds.map((id: any) => clearTimeout(id));
    }
}

export const handlePointerMove = (event: any) => {
    const dispatch = store.dispatch;
    const {activePointerProgressBar} = store.getState().controller;
    const {left} = store.getState().videoData.videoElementSizeInfo;
    const clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
    const progressTooltip: any = document.querySelector(".pl-progressTooltip");
    if (clientX > left + footerPadding()) {
        if (progressTooltip) {
            progressTooltip.style.display = "block !important";
            progressTooltip.style.pointerEvents = "auto";
        }
        if (activePointerProgressBar) {
            dispatch(setDelayTurnOffControlbar(true));
            handleTimeTooltip(event);
            handleProgressTime(event);
            videoTag().pause();
        }
    } else if (progressTooltip) {
        progressTooltip.style.display = "none !important";
        progressTooltip.style.pointerEvents = "none";
    }
}

export const handlePointerUp = (event: any, setTimeoutIds: (timeoutIds: any[]) => void, timeoutIds: any, setIsPointerDown: (value: boolean) => void) => {
    setIsPointerDown(false);
    event.preventDefault();
    event.stopPropagation();
    const dispatch = store.dispatch;
    const { duration, hlsLiveSyncPosition } = store.getState().controller;
    const { left, right } = store.getState().videoData.videoElementSizeInfo;
    const durationValue = conditions(ConditionName.isLiveParam) ? hlsLiveSyncPosition : duration;
    event.target.removeEventListener("pointermove", handlePointerMove);
    const clientX = event.clientX !== undefined ? event.clientX : event.touches[0].clientX;
    let currentTime = 0;
    if (clientX > left + footerPadding() && clientX < right + footerPadding()) currentTime = getPointerTime(event)!;
    else if (clientX < left + footerPadding()) currentTime = 0;
    else if (clientX > footerPadding()) currentTime = durationValue;
    if (!conditions(ConditionName.isStaticFormat)) handleVideoTimeline(videoTag().currentTime, currentTime);
    videoTag().currentTime = currentTime;
    if (store.getState().controller.activePointerProgressBar) {
        dispatch(setActivePointerProgressBar(false));
        dispatch(setDelayTurnOffControlbar(false));
        videoTag().play();
        handleTimeTooltip(event, true);
        sessionStorage.setItem("current-time", String(currentTime));
        handleProgressTime(event);
        handleTimeout(event, dispatch, setTimeoutIds, timeoutIds);
    }
}

const handleTimeout = (event: any, dispatch: any, setTimeoutIds: (timeoutIds: any[]) => void, timeoutIds: any) => {
    const ids = timeoutIds;
    let timeoutIdTemp = setTimeout(() => {
        const { settingPopover, markersListPopover } = store.getState().popovers;
        const { delayTurnOffControlbar } = store.getState().controller;
        if (event.pointerType === "touch" && !settingPopover && !markersListPopover && delayTurnOffControlbar) dispatch(setActiveElements(false));
    }, activeElementsTime);
    ids.push(timeoutIdTemp);
    setTimeoutIds(ids);
}

export const handleCatchUpLoadingLog = () => {
    const timer = Date.now();
    videoTag().play().then(() => sendFluentLog(catchUpLoadingLog(Date.now() - timer)));
}

export const handleMouseMove = (event: any) => handleTimeTooltip(event);

export const handleMouseOut = () => {
    const progressBarTooltip: any = document.querySelector(".pl-progressTooltip");
    hideProgressTooltip(progressBarTooltip);
}

/////// vtt tooltip
const deconstructTimestamp = (timestamp: string) => {
    const splitStampMilliseconds = timestamp.split(".");
    const timeParts = splitStampMilliseconds[0];
    const timePartsSplit = timeParts.split(":");

    return {
        milliseconds: parseInt(splitStampMilliseconds[1], 10) || 0,
        seconds: parseInt(timePartsSplit.pop()!, 10) || 0,
        minutes: parseInt(timePartsSplit.pop()!, 10) || 0,
        hours: parseInt(timePartsSplit.pop()!, 10) || 0,
    };

}

const getSecondsFromTimestamp = (timestamp: string) => {
    const timestampParts: any = deconstructTimestamp(timestamp);

    return parseInt((timestampParts.hours * (60 * 60)) +
        (timestampParts.minutes * 60) +
        timestampParts.seconds +
        (timestampParts.milliseconds / 1000), 10);
}

const getPropsFromDef = (def: string) => {
    const imageDefSplit = def.split(/#xywh=/i);
    const imageUrl = imageDefSplit[0];
    const imageCoords = imageDefSplit[1];
    const splitCoords: any = imageCoords.match(/[0-9]+/gi);

    return {
        x: splitCoords[0],
        y: splitCoords[1],
        w: splitCoords[2],
        h: splitCoords[3],
        image: imageUrl,
    };
}

const getFullyQualifiedUrl = (path: string, base: string) => {
    if (path.indexOf("//") >= 0) {
        // We have a fully qualified path.
        return path;
    }

    if (base.indexOf("//") === 0) {
        // We don't have a fully qualified path, but need to
        // be careful with trimming.
        return [
            base.replace(/\/$/gi, ""),
            path.trim(),
        ].join("/");
    }

    if (base.indexOf("//") > 0) {
        // We don't have a fully qualified path, and should
        // trim both sides of base and path.
        return [
            base.trim(),
            path.trim(),
        ].join("/");
    }

    // If all else fails.
    return path;
}

const getVttCss = (vttImageDef: string, vttUrl: string) => {
    const cssObj: any = {};
    // If there isn't a protocol, use the VTT source URL.
    let baseSplit: string = (vttUrl)!.split(/\/\w+\.vtt\s?/)[0];

    /// offset : (vttUrl)!.split(/\/\w+\.vtt\s?/)[1]

    vttImageDef = getFullyQualifiedUrl(vttImageDef, baseSplit);

    if (!vttImageDef.match(/#xywh=/i)) {
        cssObj.background = "url(\"" + vttImageDef + (vttUrl)!.split(/\/\w+\.vtt\s?/)[1] + "\")";
        return cssObj;
    }

    const imageProps = getPropsFromDef(vttImageDef);

    cssObj.background = "url(\"" + imageProps.image + (vttUrl)!.split(/\/\w+\.vtt\s?/)[1] + "\") no-repeat -" + imageProps.x + "px -" + imageProps.y + "px";
    cssObj.width = imageProps.w + "px";
    cssObj.height = imageProps.h + "px";
    cssObj.url = imageProps.image;

    return cssObj;
}

export const fetchFile = (url: string, setVttPool: any) => {
    fetch(url)
        .then(response => {
            if (!response.ok) {
                store.dispatch(setInfo({
                    ...store.getState().videoData.details,
                    vtt: undefined,
                    vtt_mobile: undefined
                }));
                throw new Error("Network response was not ok");
            }
            return response.text();
        })
        .then(data => {
            const processedVtts: any[] = [];
            const vttDefinitions = data.split(/[\r\n][\r\n]/i);
            vttDefinitions.forEach((vttDef) => {
                if (vttDef.match(/([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3})?( ?--> ?)([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3}).*/gi)) {
                    const vttDefSplit = vttDef.split(/[\r\n]/i);
                    const vttTiming = vttDefSplit[0];
                    const vttTimingSplit = vttTiming.split(/ ?--> ?/i);
                    const vttTimeStart = vttTimingSplit[0];
                    const vttTimeEnd = vttTimingSplit[1];
                    const vttImageDef = vttDefSplit[1];
                    const vttCssDef = getVttCss(vttImageDef, url);

                    processedVtts.push({
                        start: getSecondsFromTimestamp(vttTimeStart),
                        end: getSecondsFromTimestamp(vttTimeEnd),
                        css: vttCssDef,
                    });

                }
            });
            setVttPool(processedVtts);
        })
        .catch(error => {
            console.error("Error fetching file:", error);
        });
}

export const getStyleForTime = (time: number, vttPool:any, cache: any) => {
    for (let i = 0; i < vttPool.length; ++i) {
        const item = vttPool[i];
        if (time >= item.start && time < item.end) {
            // Cache miss
            if (item.css.url && !cache[item.css.url]) {
                const objectVtt: any = {
                    background: item.css.background,
                    width: item.css.width,
                    height: item.css.height,
                }
                cache[item.css.url] = objectVtt;
                return objectVtt;
            } else if (item.css.url) return cache[item.css.url]
        }
    }
}